class Share {

	constructor (params) {
		this.$cache       = {};
		this.$cache.main  = params.target;

		// Trigger init functions
		this.$cache.main  = params.target;
		this.defaultTitles = {
			"facebook" : 'Partager sur Facebook',
			"twitter" : 'Partager sur Twitter',
			"linkedin" : 'Partager sur LinkedIn',
		};
		this.url = window.location.href;
		this.title = $('title:first').text();
		this.text = $('[property="og:description"]').attr('content') || '';
		this.winHeight = 350;
		this.winWidth = 600,

		//this.init();
		this.init();
		this.initEventsConst();
		this.registerEvents();
	}
	
	init() {
		let $cta = this.$cache.main;

		if ($cta.data('url')) {
		  this.url = $cta.attr('data-url');
		}

		if ($cta.data('title')) {
		  this.title = $cta.attr('data-title');
		}

		if ($cta.data('text')) {
		  this.text = $cta.attr('data-text');
		}
	}

	initEventsConst() {
		this.onClickEvent = (e) => this.onClick(e);
	}
	
	registerEvents() {
		this.$cache.main.on('click', this.onClickEvent);
	}

	onClick(e) {
		e.preventDefault();

		let $cta = $(e.currentTarget);

        console.log($cta);

		if ($cta.data('type') === 'facebook') {
			this.shareFacebook();
		} else if ($cta.data('type') === 'twitter') {
			this.shareTwitter();
		} else if ($cta.data('type') === 'linkedin') {
			this.shareLinkedIn();
		} else if ($cta.data('type') === 'email') {
			this.shareEmail();
		}
	}

	/**
	 * Facebook share
	 */
	shareFacebook() {
		let wParams = this.generateWindowParams();
		window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.url), this.defaultTitles.facebook, wParams);
	}

	/**
	 * Twitter share
	 */
	shareTwitter() {
		let wParams = this.generateWindowParams();
		window.open('http://twitter.com/share?url=' + encodeURIComponent(this.url) + '&text=' + encodeURIComponent(this.text) + '&count=none/', this.defaultTitles.twitter, wParams);
	}

	/**
	 * LinkedIn share
	 */
	shareLinkedIn() {
		let wParams = this.generateWindowParams();
		window.open('https://www.linkedin.com/cws/share?url=' + encodeURIComponent(this.url), this.defaultTitles.linkedin, wParams);
	}

	 /**
	 * Email share
	 */
	shareEmail() {
		window.location = 'mailto:?subject=' + this.title + '&body=' + this.url  + ' ' + this.text;
	}

	generateWindowParams() {
		let winTop = ($(window).height() / 2) - (this.winHeight / 2);
		let winLeft = ($(window).width() / 2) - (this.winWidth / 2);
		let windowParam = 'top=' + winTop + ', left=' + winLeft + ', toolbar=0, status=0, width=' + this.winWidth + ', height=' + this.winHeight;

		return windowParam;
	}
}

export default Share;


// WEBPACK FOOTER //
// ./scripts/components/share.js